import React from 'react';
import { styled } from '@material-ui/core/styles';

import { ICustomTheme } from 'interfaces';

interface ContainerStyleProps {
  isMobile: boolean;
  hasResultEntryEnabled: boolean;
  className?: string;
  children?: React.ReactNode;
}

// Filters custom style props so they never reach the DOM <div>
const FilteredDiv: React.FC<ContainerStyleProps> = ({
  isMobile: _isMobile,
  hasResultEntryEnabled: _hasResultEntryEnabled,
  ...rest
}) => React.createElement('div', rest);

export const StyledContainer = styled(FilteredDiv)(
  ({
    isMobile,
    hasResultEntryEnabled,
    theme,
  }: {
    isMobile: boolean;
    hasResultEntryEnabled: boolean;
    theme: ICustomTheme;
  }) => ({
    backgroundColor: isMobile ? theme.colors.white : 'transparent',
    borderRadius: isMobile ? theme.spacing(5) : 'none',
    boxShadow: isMobile ? theme.shadows[4] : 'none',
    padding: isMobile ? theme.spacing(1) : 'none',
    width: isMobile ? '100%' : theme.spacing(7.5),
    maxWidth: isMobile ? theme.spacing(38) : theme.spacing(7.5),
    position: 'sticky',
    bottom: isMobile ? '5%' : '20%',
    left: isMobile ? 'calc(50% - 152px)' : '100%',
    transform: isMobile
      ? 'none'
      : `translateX(${hasResultEntryEnabled ? 30 : 80}px)`,
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1),
    height: 'auto',
    flexDirection: isMobile ? 'row' : 'column',
    marginTop: isMobile ? theme.spacing(2) : 0,
    flexWrap: 'wrap',
  }),
);
